import { useState } from 'react';

import { Client } from '@/common/services/Client';

import { exportComparatorExcel } from '../api/ExportComparatorExcel';

export function useExportComparatorExcel() {
  const [isExporting, setIsExporting] = useState(false);

  const exportExcel = async (
    renewalUuid: string,
    fileName: string,
  ): Promise<void> => {
    setIsExporting(true);
    try {
      const blob = await exportComparatorExcel(renewalUuid);
      Client.downloadBlob({ blob, fileName });
    } finally {
      setIsExporting(false);
    }
  };

  return { exportExcel, isExporting };
}
